import React, { useContext, useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import Typography from '../../../../Typography'
import { currencyFormatter } from '../../../../../utils/functions'
import Button from '../../../../Button'
import styles from './YearbookForm.module.sass'
import useBreakpoints from '../../../../../hooks/use-breakpoints'
import { Cart, OrderPackage, School } from '../../../../../models'
import TextInput from '../../../../TextInput'
import { useHistory } from 'react-router-dom'
import { CustomerContext } from '../../../../../contexts/CustomerContext'

const YearbookForm = ({
  student, school, defaultYearbook, yearbooks = [], pushToNextRoute = true, afterAdd = () => {}, buttonText = 'Continue', messageId
}) => {
  const [yearbook, setYearbook] = useState(defaultYearbook)
  const breakpoint = useBreakpoints()
  const history = useHistory()
  const { customer, setCustomer } = useContext(CustomerContext)
  const quantityOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
  ]
  const [quantity, setQuantity] = useState(quantityOptions[0].value)
  const [email, setEmail] = useState(customer && customer.email ? customer.email : '')

  const pricePerYearbook = useMemo(() => {
    if (!yearbook) return 0

    const prices = yearbook.options.map((option) => option.prices).flat()

    const schoolPrice = prices.find((price) => price.school)

    if (schoolPrice) return schoolPrice.price

    const genericPrice = prices.find((price) => price.price)

    return genericPrice.price
  }, [yearbook && yearbook.id])

  const myCart = () => {
    if (customer && customer.cart) {
      customer.cart.school = school

      const initializedCart = new Cart(customer.cart);
      initializedCart.isPersisted = true;
      initializedCart.messageId = messageId;

      return initializedCart;
    }

    return new Cart({ email, schoolId: student.schoolId, messageId });
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();

    const cart = myCart();

    const orderPackages = Array.from(Array(parseInt(quantity, 10)).keys());

    cart.orderPackages = orderPackages.map(() => new OrderPackage({
      optionId: yearbook.options && yearbook.options[0].id,
      price: pricePerYearbook,
      packageId: yearbook.id,
      studentId: student.id,
    }));

    cart
      .save({ with: 'orderPackages' })
      .then(() => {
        setCustomer({
          ...customer, email, priorityCart: cart, currentStudent: student, currentSchool: school,
        });

        if (pushToNextRoute) history.push('/review');
        afterAdd();
      });
  };

  useEffect(() => {
    if (breakpoint === 'sm') {
      document.body.style.background = '#efefef'
    } else {
      document.body.style.background = '#fff'
    }
  }, [breakpoint])

  if (!yearbook) return null

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div>
        <label>
          <Typography>School:</Typography>
          <Typography weight="bold">{school.name}</Typography>
        </label>
      </div>
      <div>
        <label>
          <Typography>Student:</Typography>
          <Typography weight="bold">{student.fullName(true)}</Typography>
        </label>
      </div>
      <div>
        <label>
          <Typography>Price per panorama:</Typography>
          <Typography weight="bold">{currencyFormatter(pricePerYearbook)}</Typography>
        </label>
      </div>
      <div className={styles.bottom}>
        {history.length <= 2 && (
          <label className={styles.subrow}>
            <Typography>Email:</Typography>
            <TextInput required type="email" val={email} onChange={(evt) => setEmail(evt.target.value)} />
          </label>
        )}
        {yearbooks.length > 1 && (
          <label className={styles.subrow}>
            <Typography>Select Yearbook</Typography>
            <Select
              value={{ label: yearbook.name, value: yearbook.id }}
              onChange={(opt) => setYearbook(yearbooks.find((yearbookPackage) => yearbookPackage.id === opt.value))}
              options={yearbooks.map((yearbookPackage) => ({
                label: yearbookPackage.name,
                value: yearbookPackage.id,
              }))}
            />
          </label>
        )}
        <label className={styles.subrow}>
          <Typography>Quantity:</Typography>
          <Select
            value={{ label: quantity.toString(), value: quantity }}
            onChange={(opt) => setQuantity(opt.value)}
            options={quantityOptions}
          />
        </label>
        <label className={styles.subrow}>
          <Typography>Subtotal:</Typography>
          <Typography weight="bold">{currencyFormatter(quantity * pricePerYearbook)}</Typography>
        </label>
      </div>
      <Button fullWidth variant="primary" circular type="submit">{buttonText}</Button>
    </form>
  )
}

export default YearbookForm
